var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 253.36,
    height: 44.53,
    viewBox: "0 0 253.36 44.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.763,
    y1: 1.253,
    x2: -0.219,
    y2: 0.274,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0071bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "aqua"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.96,
    y1: 0.954,
    x2: 0.076,
    y2: 0.019,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.814,
    y1: 1.069,
    x2: -0.698,
    y2: 0.022,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.472,
    y1: 1.128,
    x2: -0.494,
    y2: -0.807,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M70.849,32.261,60.121,6.413a7.356,7.356,0,0,0-6.815-4.549H43.1a3.3,3.3,0,1,0,0,2.872H53.308a4.49,4.49,0,0,1,4.159,2.778L68.2,33.361a1.437,1.437,0,0,0,2.654-1.1ZM40.13,4.54A1.237,1.237,0,1,1,41.367,3.3,1.239,1.239,0,0,1,40.13,4.54Z",
    transform: "translate(-28.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M16.9,36.549a1.433,1.433,0,0,0-1.881.766L3.085,65.658a3.3,3.3,0,1,0,2.661,1.079l11.917-28.3A1.439,1.439,0,0,0,16.9,36.549ZM3.3,70.186a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,3.3,70.186Z",
    transform: "translate(0 -27.716)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M89.55,61.745,79.681,38.016A2.779,2.779,0,0,0,77.114,36.3h0a2.779,2.779,0,0,0-2.568,1.706l-4.188,9.723A1.437,1.437,0,0,0,73,48.842l4.106-9.529,9.7,23.332a3.3,3.3,0,1,0,2.738-.9Zm-.443,4.506a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,89.108,66.251Z",
    transform: "translate(-53.432 -27.613)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M54.54,97.66a3.3,3.3,0,0,0-2.979,1.89h-2.1a4.414,4.414,0,0,0-4.085,2.723L40.919,112.98a1.436,1.436,0,1,0,2.651,1.1l4.458-10.706a1.549,1.549,0,0,1,1.431-.955h2.125A3.3,3.3,0,1,0,54.54,97.66Zm0,4.54a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,54.54,102.2Z",
    transform: "translate(-31.043 -74.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M70.849,32.261,60.121,6.413a7.356,7.356,0,0,0-6.815-4.549H43.1a3.3,3.3,0,1,0,0,2.872H53.308a4.49,4.49,0,0,1,4.159,2.778L68.2,33.361a1.437,1.437,0,0,0,2.654-1.1ZM40.13,4.54A1.237,1.237,0,1,1,41.367,3.3,1.239,1.239,0,0,1,40.13,4.54Z",
    transform: "translate(-28.016)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M16.9,36.549a1.433,1.433,0,0,0-1.881.766L3.085,65.658a3.3,3.3,0,1,0,2.661,1.079l11.917-28.3A1.439,1.439,0,0,0,16.9,36.549ZM3.3,70.186a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,3.3,70.186Z",
    transform: "translate(0 -27.716)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M89.55,61.745,79.681,38.016A2.779,2.779,0,0,0,77.114,36.3h0a2.779,2.779,0,0,0-2.568,1.706l-4.188,9.723A1.437,1.437,0,0,0,73,48.842l4.106-9.529,9.7,23.332a3.3,3.3,0,1,0,2.738-.9Zm-.443,4.506a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,89.108,66.251Z",
    transform: "translate(-53.432 -27.613)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M54.54,97.66a3.3,3.3,0,0,0-2.979,1.89h-2.1a4.414,4.414,0,0,0-4.085,2.723L40.919,112.98a1.436,1.436,0,1,0,2.651,1.1l4.458-10.706a1.549,1.549,0,0,1,1.431-.955h2.125A3.3,3.3,0,1,0,54.54,97.66Zm0,4.54a1.237,1.237,0,1,1,1.237-1.237A1.239,1.239,0,0,1,54.54,102.2Z",
    transform: "translate(-31.043 -74.29)",
    fill: "url(#linear-gradient-4)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    transform: "translate(48.483 0.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M222.417,24.261H210.77l-2.221,5.375H202.6L213.78,4.55h5.734L230.73,29.636h-6.09Zm-1.828-4.408-3.977-9.6-3.977,9.6Z",
    transform: "translate(-202.6 -4.124)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M331.08,4.55h5.806V24.905h12.578v4.731H331.08Z",
    transform: "translate(-300.334 -4.124)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M413.9,46.93h10.142v4.48H413.9Z",
    transform: "translate(-363.335 -36.362)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M499.629,18.868a6.279,6.279,0,0,1,1.218,3.925,5.8,5.8,0,0,1-2.563,5.071q-2.563,1.773-7.471,1.773H477.84V4.55h12.255q4.587,0,7.043,1.756a5.557,5.557,0,0,1,2.455,4.767,6.025,6.025,0,0,1-3.333,5.518A6.632,6.632,0,0,1,499.629,18.868ZM483.61,8.922v5.913h5.77a5.822,5.822,0,0,0,3.262-.754,2.512,2.512,0,0,0,1.11-2.221,2.47,2.47,0,0,0-1.11-2.2,5.936,5.936,0,0,0-3.262-.735Zm10.23,15.591a2.58,2.58,0,0,0,1.165-2.328q0-3.119-4.623-3.118H483.61v6.2h6.772A6.465,6.465,0,0,0,493.84,24.513Z",
    transform: "translate(-411.974 -4.124)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M598.429,24.261H586.782l-2.223,5.375H578.61L589.793,4.55h5.734l11.216,25.086H600.65ZM596.6,19.853l-3.977-9.6-3.98,9.6Z",
    transform: "translate(-488.629 -4.124)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M703.331,27.906a13.51,13.51,0,0,1-4.461-2.1l1.972-4.372a13.411,13.411,0,0,0,3.834,1.9,14.378,14.378,0,0,0,4.444.716,7.083,7.083,0,0,0,3.654-.735,2.22,2.22,0,0,0,1.182-1.953,1.862,1.862,0,0,0-.7-1.486,5.292,5.292,0,0,0-1.792-.95q-1.095-.359-2.955-.787a40.817,40.817,0,0,1-4.7-1.362,7.632,7.632,0,0,1-3.135-2.185,5.893,5.893,0,0,1-1.309-4.013,6.991,6.991,0,0,1,1.182-3.96,7.96,7.96,0,0,1,3.566-2.814A14.571,14.571,0,0,1,709.94,2.77a19.256,19.256,0,0,1,4.7.574,13.842,13.842,0,0,1,4.013,1.649L716.856,9.4A13.989,13.989,0,0,0,709.9,7.429a6.529,6.529,0,0,0-3.6.787,2.406,2.406,0,0,0-1.165,2.08,2.028,2.028,0,0,0,1.345,1.917,21.065,21.065,0,0,0,4.1,1.237,41.306,41.306,0,0,1,4.7,1.362,7.761,7.761,0,0,1,3.135,2.151,5.77,5.77,0,0,1,1.309,3.977,6.841,6.841,0,0,1-1.2,3.925,8.084,8.084,0,0,1-3.6,2.814,14.709,14.709,0,0,1-5.841,1.039A20.763,20.763,0,0,1,703.331,27.906Z",
    transform: "translate(-580.111 -2.77)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M802.65,4.55h5.806V29.636H802.65Z",
    transform: "translate(-659.056 -4.124)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M867.743,29.636,862.9,22.649h-5.339v6.988H851.76V4.55h10.857a13.957,13.957,0,0,1,5.789,1.11,8.615,8.615,0,0,1,3.781,3.154,8.7,8.7,0,0,1,1.326,4.839,8.5,8.5,0,0,1-1.345,4.82,8.5,8.5,0,0,1-3.817,3.1l5.626,8.062h-6.234Zm-1.469-19.226a6.108,6.108,0,0,0-3.977-1.13h-4.731v8.744H862.3a6.032,6.032,0,0,0,3.977-1.146,3.987,3.987,0,0,0,1.362-3.226A3.966,3.966,0,0,0,866.274,10.411Z",
    transform: "translate(-696.414 -4.124)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M977.813,29.636l-4.839-6.988h-5.339v6.988H961.83V4.55h10.857a13.957,13.957,0,0,1,5.789,1.11,8.616,8.616,0,0,1,3.781,3.154,8.7,8.7,0,0,1,1.326,4.839,8.5,8.5,0,0,1-1.345,4.82,8.5,8.5,0,0,1-3.817,3.1l5.626,8.062h-6.234Zm-1.469-19.226a6.108,6.108,0,0,0-3.977-1.13h-4.731v8.744h4.731a6.032,6.032,0,0,0,3.977-1.146,3.987,3.987,0,0,0,1.362-3.226A3.973,3.973,0,0,0,976.344,10.411Z",
    transform: "translate(-780.143 -4.124)",
    fill: "url(#linear-gradient-5)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(48.552 31.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M206.886,135.352h-4V133h10.881v2.355h-4v10.132h-2.891V135.352Z",
    transform: "translate(-202.89 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M286.138,143.166v2.319H276.47V133h9.436v2.319h-6.564v2.711h5.8v2.247h-5.8v2.891h6.8Z",
    transform: "translate(-258.862 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M347.98,144.177a6.19,6.19,0,0,1-2.427-2.3,6.706,6.706,0,0,1,0-6.653,6.207,6.207,0,0,1,2.427-2.3,7.744,7.744,0,0,1,6.4-.261,5.9,5.9,0,0,1,2.2,1.642l-1.855,1.713a3.992,3.992,0,0,0-3.14-1.462,4.191,4.191,0,0,0-2.07.507,3.6,3.6,0,0,0-1.419,1.419,4.477,4.477,0,0,0,0,4.14,3.629,3.629,0,0,0,1.419,1.419,4.16,4.16,0,0,0,2.07.51,3.967,3.967,0,0,0,3.14-1.481l1.855,1.713a5.8,5.8,0,0,1-2.211,1.658,7.347,7.347,0,0,1-2.943.572A7.2,7.2,0,0,1,347.98,144.177Z",
    transform: "translate(-310.742 -132.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M435.653,133v12.487h-2.891v-5.119h-5.672v5.119H424.2V133h2.891v4.922h5.672V133Z",
    transform: "translate(-371.24 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M517.5,133v12.487h-2.372l-6.224-7.581v7.581H506.05V133h2.391l6.208,7.581V133Z",
    transform: "translate(-433.503 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M587.936,144.175a6.223,6.223,0,0,1-2.443-2.309,6.643,6.643,0,0,1,0-6.619,6.206,6.206,0,0,1,2.443-2.309,7.736,7.736,0,0,1,7,0,6.369,6.369,0,0,1,0,11.238,7.736,7.736,0,0,1-7,0Zm5.5-2.13a3.644,3.644,0,0,0,1.4-1.419,4.477,4.477,0,0,0,0-4.14,3.644,3.644,0,0,0-1.4-1.419,4.189,4.189,0,0,0-4,0,3.628,3.628,0,0,0-1.4,1.419,4.477,4.477,0,0,0,0,4.14,3.644,3.644,0,0,0,1.4,1.419,4.172,4.172,0,0,0,4,0Z",
    transform: "translate(-493.263 -132.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M672.42,133h2.891v10.132h6.26v2.355H672.42Z",
    transform: "translate(-560.06 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M738.206,144.175a6.224,6.224,0,0,1-2.443-2.309,6.644,6.644,0,0,1,0-6.619,6.207,6.207,0,0,1,2.443-2.309,7.736,7.736,0,0,1,7,0,6.369,6.369,0,0,1,0,11.238,7.736,7.736,0,0,1-7,0Zm5.5-2.13a3.644,3.644,0,0,0,1.4-1.419,4.477,4.477,0,0,0,0-4.14,3.644,3.644,0,0,0-1.4-1.419,4.189,4.189,0,0,0-4,0,3.628,3.628,0,0,0-1.4,1.419,4.477,4.477,0,0,0,0,4.14,3.644,3.644,0,0,0,1.4,1.419,4.172,4.172,0,0,0,4,0Z",
    transform: "translate(-607.573 -132.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M828.63,138.345h2.64v5.066a7.5,7.5,0,0,1-2.355,1.177,9.166,9.166,0,0,1-2.692.409,7.3,7.3,0,0,1-3.5-.83,6.177,6.177,0,0,1-2.434-2.3,6.706,6.706,0,0,1,0-6.653,6.167,6.167,0,0,1,2.453-2.3,7.441,7.441,0,0,1,3.532-.83,7.738,7.738,0,0,1,2.979.553,5.892,5.892,0,0,1,2.247,1.606l-1.855,1.713a4.3,4.3,0,0,0-3.228-1.41,4.408,4.408,0,0,0-2.123.5,3.579,3.579,0,0,0-1.445,1.409,4.437,4.437,0,0,0,0,4.157,3.671,3.671,0,0,0,1.436,1.419,4.249,4.249,0,0,0,2.1.51,4.681,4.681,0,0,0,2.247-.536v-3.657Z",
    transform: "translate(-671.875 -132.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M901.77,133h2.891v12.487H901.77Z",
    transform: "translate(-734.525 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M957.5,143.166v2.319H947.83V133h9.436v2.319H950.7v2.711h5.8v2.247h-5.8v2.891h6.8Z",
    transform: "translate(-769.563 -132.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M1017.591,144.613a6.709,6.709,0,0,1-2.221-1.043l.981-2.175a6.624,6.624,0,0,0,1.91.945,7.2,7.2,0,0,0,2.211.357,3.526,3.526,0,0,0,1.819-.366,1.1,1.1,0,0,0,.589-.972.927.927,0,0,0-.347-.739,2.647,2.647,0,0,0-.893-.474c-.364-.12-.854-.249-1.472-.392a20.2,20.2,0,0,1-2.336-.677,3.782,3.782,0,0,1-1.56-1.089,2.944,2.944,0,0,1-.651-2,3.479,3.479,0,0,1,.589-1.972,3.952,3.952,0,0,1,1.776-1.4,7.24,7.24,0,0,1,2.9-.517,9.646,9.646,0,0,1,2.336.285,6.89,6.89,0,0,1,2,.821l-.893,2.194a6.969,6.969,0,0,0-3.46-.981,3.247,3.247,0,0,0-1.792.392,1.2,1.2,0,0,0-.579,1.034,1.012,1.012,0,0,0,.668.955,10.419,10.419,0,0,0,2.041.615,20.7,20.7,0,0,1,2.336.677,3.875,3.875,0,0,1,1.56,1.07,2.876,2.876,0,0,1,.651,1.979,3.4,3.4,0,0,1-.6,1.953,4.018,4.018,0,0,1-1.792,1.4,7.314,7.314,0,0,1-2.908.517A10.007,10.007,0,0,1,1017.591,144.613Z",
    transform: "translate(-820.941 -132.095)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d6eff186437c0e651c750095af492b5.svg";
export { ForwardRef as ReactComponent };